import * as React from 'react';

import styles from './TechnicalPage.scss';
import { TechnicalPageLocale } from './technicalPage.locale';
import Header from '../Header/Header';
import TechFeatures from '../../components/TechnicalPage/TechFeatures/TechFeatures';
import Routes from '../../components/TechnicalPage/Routes/Routes';
import Protocols from '../../components/TechnicalPage/Protocols/Protocols';
import Cta from '../Cta/Cta';
import LinkButton from '../Button/LinkButton';
import headerBg from './headerBg.svg';

interface TechnicalPageProps {
  locale: TechnicalPageLocale;
}

const TechnicalPage: React.SFC<TechnicalPageProps> = ({ locale }) => (
  <>
    <Header
      title={locale.title}
      backgroundImage={headerBg}
      backgroundPosition="15% bottom"
      backgroundSize="auto"
      small
    />

    <section className="container py-8">
      <TechFeatures locale={locale.techFeatures} />
    </section>

    <section className={styles.greySection}>
      <div className="container py-8">
        <Routes locale={locale.routes} />
      </div>
    </section>

    <section className="container py-8">
      <Protocols locale={locale.protocols} />
    </section>

    <section>
      <Cta title={locale.cta.title} subtitle={locale.cta.subtitle} backgroundType="circles">
        <div className="row justify-content-center">
          <div className="col-auto mb-3 mb-sm-0">
            <LinkButton to={locale.cta.primaryButton.href}>
              {locale.cta.primaryButton.text}
            </LinkButton>
          </div>
          <div className="col-auto">
            <LinkButton to={locale.cta.secondaryButton.href} secondary>
              {locale.cta.secondaryButton.text}
            </LinkButton>
          </div>
        </div>
      </Cta>
    </section>
  </>
);

export default TechnicalPage;



// WEBPACK FOOTER //
// /www/client/src/components/TechnicalPage/TechnicalPage.tsx